import { render } from "./Todo.vue?vue&type=template&id=af2c0786&scoped=true&bindings={\"isEditing\":\"data\",\"newTodoDescription\":\"data\",\"description\":\"props\",\"completed\":\"props\",\"startEditing\":\"options\",\"finishEditing\":\"options\"}"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"

import "./Todo.vue?vue&type=style&index=0&id=af2c0786&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af2c0786"

export default script